// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1FIdX","containerItemsCenter":"Skeleton_containerItemsCenter__3VhNf"};